export function formatarValorBR(valor) {

    if (isNaN(valor)) return "0,00";
    
    return valor.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });

}